import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ServicioAuthService } from '../servicio-auth.service';
import { ServicioAesService } from '../servicio-aes.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor(private authService: ServicioAuthService,
              private router: Router,
              private aesEncrypt: ServicioAesService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request: any = req;
    let token = '';
    const credential = localStorage.getItem('auth-report');
    if (credential) {
      const aesDecrypt = this.aesEncrypt.decrypt(credential);
      token = aesDecrypt.split(' ')[1];
      if (token) {
        request = req.clone({ setHeaders : { authorization : `Bearer ${token}`}});
      }
    }

    return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        this.authService.clearLogin();
        this.router.navigate(['/login']);
      }
      return throwError(err);
    }));
  }
}
